import { Outlet } from "react-router-dom"
import { CustomRoutePropsType } from "../../../Types/CustomRoutePropsType"

export const Layout = (props:{routes:CustomRoutePropsType[]}) => {

    return <>
        {/* <h1>Public Layout</h1> */}
        <Outlet/>
    </>
}